<script lang="ts">
  let { message = null }: { message?: string | null } = $props();

  const waitSentences = [
    'Getting ready to belt it out',
    'Warming up those golden pipes',
    "Let's limber up those vocal cords!",
    'Get ready to hit all the right notes!',
    "It's time to harmonize with your device!",
    "Let's tune up your voice with some exercises!",
    'Get ready to sing your heart out!',
    'Ready to hit those high notes? Let\'s go!',
    'Prepare to be pitch perfect!',
    "Let's get those vocal cords in shape!",
    "It's time to unleash your inner diva!",
    'Warm up those pipes, the show is about to begin!',
    'Get those vocal cords flexing and stretching!',
    "It's time to give those pipes a workout!",
  ];

  const waitSentence = waitSentences[Math.floor(Math.random() * waitSentences.length)];
</script>

<div class="text-center mt-4">
  <span class="text-3xl md:text-5xl text-primary-500">
    <i class="fas fa-spinner fa-pulse"></i>
  </span>
  <p class="text-base md:text-lg mt-2">{waitSentence}</p>
  {#if message}
    <p class="mt-2 text-sm text-gray-500">{message}</p>
  {/if}
</div>
